package com.dignicate.web.data.markdown.parser.handlers

import com.dignicate.web.data.markdown.model.MarkdownBlock
import com.dignicate.web.data.markdown.parser.core.MarkdownHandler
import com.dignicate.web.data.markdown.parser.core.ParsingContext

class HeadingHandler : MarkdownHandler {
    override fun canHandle(ctx: ParsingContext): Boolean {
        return ctx.currentLine()?.startsWith("#") == true
    }

    override fun handle(ctx: ParsingContext) {
        val line = ctx.currentLine()!!
        val level = line.takeWhile { it == '#' }.length
        val text = line.drop(level).trim()
        ctx.blocks.add(MarkdownBlock.Heading(level, text))
        ctx.index++
    }
}
